(function (global) {
  (function (n) {
    'use strict';
  })(global);

  /**
   * Thực hiện render file js theo môi trường
   */
  (() => {
    'use strict';

    function renderScr(src, callback) {
      let js = document.createElement('script');
      js.src = src;

      // Thêm sự kiện sau khi load thành công
      if (callback && typeof callback == 'function') {
        if (js.readyState) {
          // only required for IE <9
          js.onreadystatechange = function () {
            if (js.readyState === 'loaded' || js.readyState === 'complete') {
              js.onreadystatechange = null;
              callback();
            }
          };
        } else {
          //Others
          js.onload = function () {
            callback();
          };
        }
      }

      document.head.append(js);
    }

    // MisaID Profile
    renderScr(`${window._misaId.cdnUrl}${window._misaId.profile}`);
  })();
})();
